var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('navigation-row', _vm._b({}, 'navigation-row', {
    items: _vm.items
  }, false));
}
var staticRenderFns = []

export { render, staticRenderFns }